module.exports = __webpack_public_path__ + "media/directory/social_icon_hover-0eaf217e.svg";